export default {
  en: {
    short: {
      year: 'numeric', month: 'long', day: 'numeric'
    }
  },
  pt: {
    short: {
      year: 'numeric', month: 'long', day: 'numeric'
    }
  }
}
